// Frontend/src/axiosConfig/axiosConfig.js
// Si el backend corre en otro puerto, crear .env con REACT_APP_API_URL=http://localhost:5050 (o el puerto que uses)
import axios from 'axios';
import { getAuthValue, clearAuthSession } from '../lib/authSession';
import { API_BASE_URL, buildExpiredSessionLoginPath } from '../config/runtime';

const instance = axios.create({
    // Vacío = usa proxy de package.json (localhost:3000). Si backend está en otro puerto: REACT_APP_API_URL=http://localhost:PUERTO
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});

// Enviar token en todas las peticiones para rutas protegidas (reservas, etc.)
instance.interceptors.request.use((config) => {
    const token = getAuthValue('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Manejar 401 (sesión expirada) y 403 (sin permisos)
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        const url = error.config?.url || '';
        const esLogin = /(admins|profesionales|gestores-consultorios|pacientes|responsables)\/login/.test(url);
        const tieneSesionActiva = !!getAuthValue('auth');
        if (status === 401 && !esLogin && tieneSesionActiva) {
            clearAuthSession();
            window.location.href = buildExpiredSessionLoginPath();
        } else if (status === 403) {
            console.error('Acceso denegado (403):', error.response?.data?.error || error.message);
        }
        return Promise.reject(error);
    }
);

export default instance;